import type { ITotalEngagementStatsFacility } from '../model/engagementStatsFacility';

interface ITotalStatisticItem {
  dataKey: keyof ITotalEngagementStatsFacility;
  label: string;
  unit: string;
  tooltipText: string;
}

export const totalStatisticsItems: ITotalStatisticItem[] = [
  {
    dataKey: 'avg_age',
    label: 'Age',
    unit: 'days',
    tooltipText:
      'The number of days since the action item was created. Note that the date range beneath the day count represents the creation date and the date of the latest update/completion report.',
  },
  {
    dataKey: 'avg_customer_response',
    label: 'Time Awaiting Site Response',
    unit: 'days',
    tooltipText:
      'The total number of days during which Waites was awaiting a response from the site (that is, the days the action item was in the “New“, “Needs Response“, and “Awaiting Update“ statuses).',
  },
  {
    dataKey: 'avg_customer_response_average',
    label: 'Site Response',
    unit: 'days',
    tooltipText:
      'The average number of days the action item was in the “New“, “Needs Response“, or “Awaiting Update“ statuses before a customer response or completion report.',
  },
  {
    dataKey: 'avg_days_after_first_customer_reaction',
    label: 'Initial Response',
    unit: 'days',
    tooltipText: 'The number of days the action item was in the “New” status before there was a response.',
  },
];
